<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <loading-component>
        <template #content>
            <div class="flex flex-col gap-4 xl:mx-60">
                <div class="flex flex-row items-center gap-4">
                    <back-component></back-component>
                    <span class="text-2xl font-bold text-secondary">{{ client.name }}</span>
                </div>

                <upsert-client-component v-model="client" mode="update" @save="save" />
            </div>
        </template>
    </loading-component>
</template>

<script>
import BackComponent from '@/components/BackComponent';
import UpsertClientComponent from '@/components/clients/UpsertClientComponent';
import Notifications from '@auth/vue-share/utility/notifications';
import { mapStores } from 'pinia';
import { useClientsStore } from '@/stores/clients';
import LoadingComponent from '@/components/LoadingComponent';
import { useApplicationStore } from '@/stores/application';
import logger from '@auth/vue-share/utility/logger';

export default {
    name: 'EditClientView',
    props: ['id'],
    components: { LoadingComponent, UpsertClientComponent, BackComponent },
    data() {
        return {
            client: undefined
        };
    },
    computed: {
        ...mapStores(useClientsStore, useApplicationStore)
    },
    async created() {
        this.applicationStore.setLoading(true);
        this.clientsStore.getClient(this.id).then((response) => {
            this.client = response.data.data;
            this.applicationStore.setLoading(false);
        });
    },
    methods: {
        save(client) {
            this.clientsStore
                .updateClient(client)
                .then(() => {
                    Notifications.success('Anwedung erfolgreich gespeichert');
                })
                .catch((error) => {
                    Notifications.success('Anwendung konnte nicht gespeichert werden');
                    logger.error('[CLIENT]', error);
                });
        }
    }
};
</script>

<style scoped></style>
